const NoData = () => (
  <div className="noData">
    <p> No data ... </p>
  </div>
);

export default NoData;
